{
  "PROFILE_SETTINGS": {
    "LINK": "Налаштування облікового запису",
    "TITLE": "Налаштування облікового запису",
    "BTN_TEXT": "Оновити обліковий запис",
    "DELETE_AVATAR": "Видалити аватар",
    "AVATAR_DELETE_SUCCESS": "Аватар був успішно видалений",
    "AVATAR_DELETE_FAILED": "Виникла помилка під час видалення аватару, будь ласка, спробуйте ще раз",
    "UPDATE_SUCCESS": "Ваш профіль було успішно оновлено",
    "PASSWORD_UPDATE_SUCCESS": "Ваш пароль було успішно змінено",
    "AFTER_EMAIL_CHANGED": "Ваш обліковий запис було успішно оновлено. Будь ласка, увійдіть знову, оскільки ваші дані були змінені",
    "FORM": {
      "PICTURE": "Фото профілю",
      "EMAIL_SIGNATURE_PICTURE": {
        "LABEL": "Зображення для підпису електронної пошти",
        "HINT": "Використовується в підписах електронної пошти. {'{{'}email_signature_picture{'}}'} замінюється URL-адресою цього зображення (а не тегом зображення) — використовуйте його як джерело зображення (атрибут src тега img) у своєму підписі або підписі скриньки. Якщо не встановлено, нічого не вставляється.",
        "DELETE_SUCCESS": "Зображення для підпису електронної пошти успішно видалено",
        "DELETE_FAILED": "Під час видалення зображення для підпису електронної пошти сталася помилка, спробуйте ще раз"
      },
      "AVATAR": "Зображення облікового запису",
      "ERROR": "Будь ласка, виправте помилки форми",
      "REMOVE_IMAGE": "Видалити",
      "UPLOAD_IMAGE": "Завантажити зображення",
      "UPDATE_IMAGE": "Оновити зображення",
      "PROFILE_SECTION": {
        "TITLE": "Анкета",
        "NOTE": "Ваша електронна адреса - це ваша ідентифікація і використовується для входу."
      },
      "SEND_MESSAGE": {
        "TITLE": "Комбінація клавіш для надсилання повідомлень",
        "NOTE": "Ви можете обрати гарячу клавішу (Enter або Cmd/Ctrl+Enter) на основі ваших вподобань.",
        "UPDATE_SUCCESS": "Ваші налаштування були успішно оновлені",
        "CARD": {
          "ENTER_KEY": {
            "HEADING": "Enter (↵)",
            "CONTENT": "Надсилати повідомлення, натиснувши клавішу Enter замість кнопки надсилання."
          },
          "CMD_ENTER_KEY": {
            "HEADING": "Cmd/Ctrl + Enter (⌘ + ↵)",
            "CONTENT": "Надсилати повідомлення, натиснувши комбінацію Cmd/Ctrl + Enter замість кнопки надсилання."
          }
        }
      },
      "INTERFACE_SECTION": {
        "TITLE": "Інтерфейс",
        "NOTE": "Налаштуйте вигляд і відчуття від вашої панелі керування.",
        "FONT_SIZE": {
          "TITLE": "Розмір шрифту",
          "NOTE": "Налаштуйте розмір тексту на панелі керування відповідно до ваших уподобань.",
          "UPDATE_SUCCESS": "Ваші налаштування шрифту успішно оновлено",
          "UPDATE_ERROR": "Під час оновлення налаштувань шрифту сталася помилка, спробуйте ще раз",
          "OPTIONS": {
            "SMALLER": "Менший",
            "SMALL": "Малий",
            "DEFAULT": "Стандартний",
            "LARGE": "Великий",
            "LARGER": "Більший",
            "EXTRA_LARGE": "Дуже великий"
          }
        },
        "UI_LANGUAGE": {
          "TITLE": "Мова панелі керування",
          "NOTE": "Перевизначте мову облікового запису для вашої власної панелі керування. Залиште порожнім, щоб використовувати стандартну мову облікового запису.",
          "USE_ACCOUNT_DEFAULT": "Використовувати стандартну мову облікового запису",
          "API_SUCCESS": "Мову вашої панелі керування успішно оновлено",
          "API_ERROR": "Під час оновлення мови панелі керування сталася помилка, спробуйте ще раз"
        },
        "MESSAGE_TRANSLATION": {
          "TITLE": "Мова повідомлень",
          "NOTE": "Виберіть, чи відображати оригінальні повідомлення, чи їх переклади",
          "ORIGINAL": "Оригінал",
          "TRANSLATED": "Переклад"
        },
        "PASTE_BEHAVIOR": {
          "TITLE": "Поведінка вставлення",
          "NOTE": "Виберіть, як обробляти вставлений вміст під час створення повідомлень",
          "UPDATE_SUCCESS": "Ваші налаштування вставлення успішно оновлено",
          "OPTIONS": {
            "PRESERVE_ALL": {
              "HEADING": "Зберігати все форматування",
              "DESCRIPTION": "Зберігати все форматування, включно з таблицями, стилями та іншими HTML-елементами під час вставлення вмісту."
            },
            "TEXT_WITH_LINKS": {
              "HEADING": "Лише текст із посиланнями",
              "DESCRIPTION": "Перетворювати на звичайний текст, але зберігати клікабельні посилання під час вставлення вмісту."
            },
            "PLAIN_TEXT_ONLY": {
              "HEADING": "Лише звичайний текст",
              "DESCRIPTION": "Видаляти все форматування та перетворювати вміст на звичайний текст під час вставлення."
            }
          }
        },
        "REPLY_BOX_HEIGHT": {
          "TITLE": "Висота поля відповіді",
          "NOTE": "Встановіть мінімальну висоту поля відповіді у відсотках від висоти екрана. Застосовується лише до розмов електронною поштою.",
          "UPDATE_SUCCESS": "Налаштування висоти поля відповіді успішно оновлено",
          "PERCENT_LABEL": "Висота (% від висоти екрана)",
          "OPTIONS": {
            "DEFAULT": {
              "HEADING": "За замовчуванням",
              "DESCRIPTION": "Поле відповіді спочатку невелике й збільшується під час введення тексту."
            },
            "CUSTOM": {
              "HEADING": "Користувацька",
              "DESCRIPTION": "Поле відповіді завжди займає не менше обраного відсотка висоти екрана."
            }
          }
        }
      },
      "AUTO_NAVIGATION": {
        "TITLE": "Автоматично переходити до наступної розмови",
        "NOTE": "Автоматично переходити до наступної відкритої розмови після завершення поточної",
        "UPDATE_SUCCESS": "Налаштування автопереходу успішно оновлено"
      },
      "EMAIL_PREVIEW_FORMAT": {
        "TITLE": "Формат попереднього перегляду електронної пошти у списку розмов",
        "NOTE": "Оберіть, що відображатиметься у списку розмов для розмов зі скриньок електронної пошти",
        "SUBJECT": "Тема",
        "SUBJECT_WITH_NOTE": "Тема та останнє повідомлення, якщо це особиста нотатка",
        "UPDATE_SUCCESS": "Налаштування попереднього перегляду електронної пошти успішно оновлено"
      },
      "DISABLE_SHORTCUTS": {
        "TITLE": "Вимкнути комбінації клавіш",
        "NOTE": "Вимкнути всі комбінації клавіш у всьому застосунку",
        "UPDATE_SUCCESS": "Налаштування комбінацій клавіш успішно оновлено"
      },
      "FOLDER_ORDER": {
        "TITLE": "Порядок папок",
        "NOTE": "Налаштуйте порядок, у якому папки (власні подання) відображаються на бічній панелі. Перетягніть, щоб змінити порядок.",
        "NO_FOLDERS": "Спеціальні папки не знайдено. Створіть папки, щоб упорядкувати розмови."
      },
      "SIDEBAR_CONFIGURATION": {
        "TITLE": "Налаштування бічної панелі",
        "NOTE": "Налаштуйте, які розділи відображаються на бічній панелі розмов.",
        "SAVE_BUTTON": "Зберегти конфігурацію",
        "UPDATE_SUCCESS": "Конфігурацію бічної панелі успішно оновлено",
        "UPDATE_ERROR": "Під час оновлення конфігурації бічної панелі сталася помилка, спробуйте ще раз",
        "OPTIONS": {
          "ALL_CONVERSATIONS": "Усі розмови",
          "ALL_CONVERSATIONS_DESC": "Показувати пункт меню «Усі розмови» на бічній панелі",
          "INBOX": "Вхідні",
          "INBOX_DESC": "Показувати основну папку вхідних із непрочитаними сповіщеннями",
          "CONVERSATION_GROUPS": "Згадки та без нагляду",
          "CONVERSATION_GROUPS_DESC": "Показувати групи розмов «Згадки» та «Без нагляду»",
          "FOLDERS": "Папки",
          "FOLDERS_DESC": "Показувати спеціальні подання (папки) для впорядкованих розмов",
          "TEAMS": "Команди",
          "TEAMS_DESC": "Показувати розмови, відфільтровані за призначенням команди",
          "CHANNELS": "Вхідні канали",
          "CHANNELS_DESC": "Показувати розмови, відфільтровані за вхідними каналами",
          "LABELS": "Мітки",
          "LABELS_DESC": "Показувати розмови, відфільтровані за мітками"
        }
      },
      "PHONE_SETTINGS": {
        "TITLE": "Налаштування телефону",
        "NOTE": "Введіть облікові дані для входу до вашої PBX-системи.",
        "USERNAME": "Ім’я користувача",
        "PASSWORD": "Пароль",
        "SUBMIT": "Зберегти",
        "USERNAME_INVALID": "Ім’я користувача може містити лише літери, цифри та . _ - + — без пробілів і без електронної адреси.",
        "API": {
          "USERNAME_INVALID": "Це ім’я користувача не є дійсним SIP-іменем користувача. Використовуйте лише літери, цифри та . _ - + — без пробілів і без електронної адреси.",
          "USERNAME_TAKEN": "Це ім’я користувача вже використовується іншим агентом у цьому акаунті."
        }
      },
      "MESSAGE_SIGNATURE_SECTION": {
        "TITLE": "Особистий підпис повідомлення",
        "DESCRIPTION": "Створіть унікальний підпис повідомлення, який відображатиметься наприкінці кожного електронного листа, який ви надсилаєте. Ви також можете додати вбудоване зображення.",
        "NOTE": "Ці налаштування застосовуватимуться лише тоді, коли для вхідного каналу не встановлено HTML-підпис.",
        "BTN_TEXT": "Зберегти підпис повідомлення",
        "API_ERROR": "Не вдалося зберегти підпис! Спробуйте ще раз",
        "API_SUCCESS": "Підпис успішно збережено",
        "IMAGE_UPLOAD_ERROR": "Не вдалося завантажити зображення! Спробуйте ще раз",
        "IMAGE_UPLOAD_SUCCESS": "Зображення успішно додано. Натисніть «Зберегти», щоб зберегти підпис",
        "IMAGE_UPLOAD_SIZE_ERROR": "Розмір зображення має бути меншим за {size} МБ"
      },
      "MESSAGE_SIGNATURE": {
        "LABEL": "Підпис повідомлення",
        "ERROR": "Підпис повідомлення не може бути порожнім",
        "PLACEHOLDER": "Вставте тут ваш особистий підпис повідомлення."
      },
      "PASSWORD_SECTION": {
        "TITLE": "Пароль",
        "NOTE": "Оновлення пароля призведе до скидання входу на кількох пристроях.",
        "BTN_TEXT": "Змінити пароль"
      },
      "ACCESS_TOKEN": {
        "TITLE": "Токен доступу",
        "NOTE": "Цей токен можна використовувати, якщо ви створюєте інтеграцію на основі API",
        "COPY": "Копіювати",
        "REGENERATE": "Згенерувати знову",
        "REGENERATE_SUCCESS": "Токен доступу успішно згенеровано знову. Будь ласка, оновіть усі інтеграції, які використовують старий токен.",
        "REGENERATE_CONFIRM_TITLE": "Згенерувати токен доступу знову?",
        "REGENERATE_CONFIRM_MESSAGE": "Це зробить поточний токен недійсним. Усі інтеграції, які використовують старий токен, перестануть працювати."
      },
      "CHROME_EXTENSION": {
        "TITLE": "Розширення Chrome",
        "NOTE": "Встановіть наше розширення для Chrome, щоб отримувати розширені сповіщення про вхідні телефонні дзвінки.",
        "INSTALL_BUTTON": "Встановити розширення",
        "ALREADY_INSTALLED": "Розширення встановлено"
      },
      "AUDIO_NOTIFICATIONS_SECTION": {
        "TITLE": "Звукові сповіщення",
        "NOTE": "Увімкніть звукові сповіщення на панелі керування для нових повідомлень і розмов.",
        "PLAY": "Відтворити звук",
        "ALERT_TYPES": {
          "NONE": "Немає",
          "MINE": "Призначені",
          "ALL": "Усі",
          "ASSIGNED": "Мої призначені розмови",
          "UNASSIGNED": "Непризначені розмови",
          "NOTME": "Відкриті розмови, призначені іншим"
        },
        "ALERT_COMBINATIONS": {
          "NONE": "Ви не вибрали жодного параметра, тому не отримуватимете звукові сповіщення.",
          "ASSIGNED": "Ви отримуватимете сповіщення про розмови, призначені вам.",
          "UNASSIGNED": "Ви отримуватимете сповіщення про будь-які непризначені розмови.",
          "NOTME": "Ви отримуватимете сповіщення про розмови, призначені іншим.",
          "ASSIGNED+UNASSIGNED": "Ви отримуватимете сповіщення про призначені вам розмови та будь-які розмови без нагляду.",
          "ASSIGNED+NOTME": "Ви отримуватимете сповіщення про розмови, призначені вам та іншим, але не про непризначені.",
          "NOTME+UNASSIGNED": "Ви отримуватимете сповіщення про розмови без нагляду та ті, що призначені іншим.",
          "ASSIGNED+NOTME+UNASSIGNED": "Ви отримуватимете сповіщення про всі розмови."
        },
        "ALERT_TYPE": {
          "TITLE": "Події для звукових сповіщень у розмовах",
          "NONE": "Немає",
          "ASSIGNED": "Призначені розмови",
          "ALL_CONVERSATIONS": "Усі розмови"
        },
        "DEFAULT_TONE": {
          "TITLE": "Сигнал сповіщення:"
        },
        "CONDITIONS": {
          "TITLE": "Умови сповіщень:",
          "CONDITION_ONE": "Надсилати звукові сповіщення, лише якщо вікно браузера неактивне",
          "CONDITION_TWO": "Надсилати сповіщення кожні 10 с, доки всі призначені розмови не буде прочитано"
        },
        "SOUND_PERMISSION_ERROR": "У вашому браузері вимкнено автовідтворення. Щоб автоматично чути сповіщення, увімкніть дозвіл на звук у налаштуваннях браузера або взаємодійте зі сторінкою.",
        "READ_MORE": "Докладніше"
      },
      "EMAIL_NOTIFICATIONS_SECTION": {
        "TITLE": "Сповіщення електронною поштою",
        "NOTE": "Оновіть тут ваші налаштування сповіщень електронною поштою",
        "CONVERSATION_ASSIGNMENT": "Надсилати сповіщення електронною поштою, коли мені призначають розмову",
        "CONVERSATION_CREATION": "Надсилати сповіщення електронною поштою, коли створюється нова розмова",
        "CONVERSATION_MENTION": "Надсилати сповіщення електронною поштою, коли вас згадують у розмові",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Надсилати сповіщення електронною поштою, коли в призначеній розмові створюється нове повідомлення",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Надсилати сповіщення електронною поштою, коли в розмові, у якій ви берете участь, створюється нове повідомлення",
        "SLA_MISSED_FIRST_RESPONSE": "Надсилати сповіщення електронною поштою, коли розмова порушує SLA першої відповіді",
        "SLA_MISSED_NEXT_RESPONSE": "Надсилати сповіщення електронною поштою, коли розмова порушує SLA наступної відповіді",
        "SLA_MISSED_RESOLUTION": "Надсилати сповіщення електронною поштою, коли розмова порушує SLA вирішення"
      },
      "NOTIFICATIONS": {
        "TITLE": "Налаштування сповіщень",
        "TYPE_TITLE": "Тип сповіщення",
        "EMAIL": "Електронна пошта",
        "PUSH": "Push-сповіщення",
        "TYPES": {
          "CONVERSATION_CREATED": "Створено нову розмову",
          "CONVERSATION_ASSIGNED": "Вам призначено розмову",
          "CONVERSATION_MENTION": "Вас згадали в розмові",
          "ASSIGNED_CONVERSATION_NEW_MESSAGE": "У призначеній розмові створено нове повідомлення",
          "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "У розмові, у якій ви берете участь, створено нове повідомлення",
          "UNASSIGNED_CONVERSATION_NEW_MESSAGE": "У розмові без доступного агента створено нове повідомлення",
          "SLA_MISSED_FIRST_RESPONSE": "Розмова порушує SLA першої відповіді",
          "SLA_MISSED_NEXT_RESPONSE": "Розмова порушує SLA наступної відповіді",
          "SLA_MISSED_RESOLUTION": "Розмова порушує SLA вирішення"
        },
        "BROWSER_PERMISSION": "Увімкніть push-сповіщення для вашого браузера, щоб мати змогу їх отримувати",
        "ALLOW_NOTIFICATION_DURING_CALL": "Дозволити push-сповіщення під час дзвінка",
        "TEST_PUSH": "Тест",
        "TESTING": "Тестування...",
        "TEST_PUSH_DESCRIPTION": "Надішліть тестові сповіщення, щоб перевірити налаштування",
        "TEST_NOTIFICATION_ERROR": "Не вдалося надіслати тестове сповіщення. Спробуйте ще раз.",
        "TEST_LOCAL_TITLE": "Тестове сповіщення (локальне)",
        "TEST_LOCAL_BODY": "Це локальне сповіщення браузера. Якщо ви його бачите, сповіщення браузера працюють!"
      },
      "API": {
        "UPDATE_SUCCESS": "Ваші налаштування сповіщень успішно оновлено",
        "UPDATE_ERROR": "Під час оновлення налаштувань сталася помилка, спробуйте ще раз"
      },
      "PUSH_NOTIFICATIONS_SECTION": {
        "TITLE": "Push-сповіщення",
        "NOTE": "Оновіть тут ваші налаштування push-сповіщень",
        "CONVERSATION_ASSIGNMENT": "Надсилати push-сповіщення, коли мені призначають розмову",
        "CONVERSATION_CREATION": "Надсилати push-сповіщення, коли створюється нова розмова",
        "CONVERSATION_MENTION": "Надсилати push-сповіщення, коли вас згадують у розмові",
        "ASSIGNED_CONVERSATION_NEW_MESSAGE": "Надсилати push-сповіщення, коли в призначеній розмові створюється нове повідомлення",
        "PARTICIPATING_CONVERSATION_NEW_MESSAGE": "Надсилати push-сповіщення, коли в розмові, у якій ви берете участь, створюється нове повідомлення",
        "HAS_ENABLED_PUSH": "Для цього браузера у вас увімкнено push-сповіщення.",
        "REQUEST_PUSH": "Увімкнути push-сповіщення",
        "SLA_MISSED_FIRST_RESPONSE": "Надсилати push-сповіщення, коли розмова порушує SLA першої відповіді",
        "SLA_MISSED_NEXT_RESPONSE": "Надсилати push-сповіщення, коли розмова порушує SLA наступної відповіді",
        "SLA_MISSED_RESOLUTION": "Надсилати push-сповіщення, коли розмова порушує SLA вирішення"
      },
      "PROFILE_IMAGE": {
        "LABEL": "Зображення профілю"
      },
      "NAME": {
        "LABEL": "Ваше повне ім’я",
        "ERROR": "Будь ласка, введіть коректне повне ім’я",
        "PLACEHOLDER": "Будь ласка, введіть ваше повне ім’я"
      },
      "DISPLAY_NAME": {
        "LABEL": "Відображуване ім’я",
        "ERROR": "Будь ласка, введіть коректне відображуване ім’я",
        "PLACEHOLDER": "Будь ласка, введіть відображуване ім’я, воно буде показуватися в розмовах"
      },
      "POSITION": {
        "LABEL": "Посада",
        "ERROR": "Будь ласка, введіть коректну посаду",
        "PLACEHOLDER": "Будь ласка, введіть вашу посаду"
      },
      "CUSTOM_LINE": {
        "LABEL": "Власний рядок",
        "ERROR": "Будь ласка, введіть коректний власний рядок",
        "PLACEHOLDER": "Будь ласка, введіть ваш власний рядок"
      },
      "AVAILABILITY": {
        "LABEL": "Доступність",
        "STATUS": {
          "ONLINE": "Онлайн",
          "BUSY": "Зайнятий",
          "OFFLINE": "Офлайн"
        },
        "SET_AVAILABILITY_SUCCESS": "Статус доступності успішно встановлено",
        "SET_AVAILABILITY_ERROR": "Не вдалося встановити статус доступності, спробуйте ще раз"
      },
      "EMAIL": {
        "LABEL": "Ваша електронна адреса",
        "ERROR": "Будь ласка, введіть коректну електронну адресу",
        "PLACEHOLDER": "Будь ласка, введіть вашу електронну адресу, вона буде показуватися в розмовах"
      },
      "CURRENT_PASSWORD": {
        "LABEL": "Поточний пароль",
        "ERROR": "Будь ласка, введіть поточний пароль",
        "PLACEHOLDER": "Будь ласка, введіть поточний пароль"
      },
      "PASSWORD": {
        "LABEL": "Новий пароль",
        "ERROR": "Будь ласка, введіть пароль довжиною не менше 6 символів",
        "PLACEHOLDER": "Будь ласка, введіть новий пароль"
      },
      "PASSWORD_CONFIRMATION": {
        "LABEL": "Підтвердіть новий пароль",
        "ERROR": "Підтвердження пароля має збігатися з паролем",
        "PLACEHOLDER": "Будь ласка, повторно введіть новий пароль"
      }
    }
  },
  "SIDEBAR_ITEMS": {
    "CHANGE_AVAILABILITY_STATUS": "Змінити",
    "CHANGE_ACCOUNTS": "Перемкнути обліковий запис",
    "SWITCH_ACCOUNT": "Перемкнути обліковий запис",
    "CONTACT_SUPPORT": "Звернутися до підтримки",
    "REPORT_BUG": "Повідомити про помилку",
    "SELECTOR_SUBTITLE": "Виберіть обліковий запис із наведеного списку",
    "PROFILE_SETTINGS": "Налаштування профілю",
    "KEYBOARD_SHORTCUTS": "Комбінації клавіш",
    "APPEARANCE": "Змінити вигляд",
    "SUPER_ADMIN_CONSOLE": "Консоль SuperAdmin",
    "DOCS": "Читати документацію",
    "LOGOUT": "Вийти"
  },
  "BUG_REPORT": {
    "TITLE": "Повідомити про помилку",
    "DESCRIPTION_LABEL": "Опис проблеми",
    "DESCRIPTION_PLACEHOLDER": "Опишіть проблему, з якою ви зіткнулися...",
    "SUBMIT": "Надіслати звіт",
    "SUBMITTING": "Надсилання...",
    "CANCEL": "Скасувати",
    "SUCCESS": "Звіт про помилку успішно надіслано. Дякуємо!",
    "ERROR": "Не вдалося надіслати звіт про помилку. Спробуйте ще раз.",
    "VALIDATION_ERROR": "Будь ласка, опишіть проблему перед надсиланням"
  },
  "APP_GLOBAL": {
    "TRIAL_MESSAGE": "днів пробного періоду залишилося.",
    "TRAIL_BUTTON": "Купити зараз",
    "DELETED_USER": "Видалений користувач",
    "EMAIL_VERIFICATION_PENDING": "Схоже, ви ще не підтвердили свою електронну адресу. Будь ласка, перевірте вхідні повідомлення на наявність листа для підтвердження.",
    "RESEND_VERIFICATION_MAIL": "Надіслати лист для підтвердження ще раз",
    "EMAIL_VERIFICATION_SENT": "Лист для підтвердження надіслано. Будь ласка, перевірте вхідні повідомлення.",
    "ACCOUNT_SUSPENDED": {
      "TITLE": "Обліковий запис призупинено",
      "MESSAGE": "Ваш обліковий запис призупинено. Будь ласка, зверніться до служби підтримки для отримання додаткової інформації."
    }
  },
  "COMPONENTS": {
    "CODE": {
      "BUTTON_TEXT": "Копіювати",
      "CODEPEN": "Відкрити в CodePen",
      "COPY_SUCCESSFUL": "Скопійовано в буфер обміну"
    },
    "SHOW_MORE_BLOCK": {
      "SHOW_MORE": "Показати більше",
      "SHOW_LESS": "Показати менше"
    },
    "FILE_BUBBLE": {
      "DOWNLOAD": "Завантажити",
      "UPLOADING": "Завантаження...",
      "INSTAGRAM_STORY_UNAVAILABLE": "Ця історія більше недоступна.",
      "RECORDING_UNAVAILABLE": "Цей запис більше недоступний.",
      "DELETE_RECORDING": {
        "BUTTON": "Видалити запис дзвінка",
        "TITLE": "Видалити запис дзвінка?",
        "DESCRIPTION": "Усі записи цього дзвінка буде остаточно видалено з телефонної станції, відновити їх буде неможливо. Розшифровка та підсумок дзвінка залишаться.",
        "CONFIRM": "Видалити",
        "SUCCESS": "Запис дзвінка видалено",
        "ERROR": "Не вдалося видалити запис дзвінка. Спробуйте ще раз."
      }
    },
    "LOCATION_BUBBLE": {
      "SEE_ON_MAP": "Переглянути на мапі"
    },
    "FORM_BUBBLE": {
      "SUBMIT": "Надіслати"
    },
    "MEDIA": {
      "IMAGE_UNAVAILABLE": "Це зображення більше недоступне.",
      "LOADING_FAILED": "Не вдалося завантажити"
    }
  },
  "CONFIRM_EMAIL": "Перевірка...",
  "SETTINGS": {
    "INBOXES": {
      "NEW_INBOX": "Додати вхідний канал"
    }
  },
  "SIDEBAR": {
    "NO_ITEMS": "Немає елементів",
    "CURRENTLY_VIEWING_ACCOUNT": "Зараз переглядається:",
    "SWITCH": "Перемкнути",
    "INBOX_VIEW": "Перегляд вхідних",
    "CONVERSATIONS": "Розмови",
    "INBOX": "Мої вхідні",
    "ALL_CONVERSATIONS": "Усі розмови",
    "MENTIONED_CONVERSATIONS": "Згадки",
    "PARTICIPATING_CONVERSATIONS": "Участь",
    "UNATTENDED_CONVERSATIONS": "Без нагляду",
    "REPORTS": "Звіти",
    "SETTINGS": "Налаштування",
    "CONTACTS": "Контакти",
    "DATA_ASSISTANT": "Помічник із даних",
    "CAPTAIN": "Captain",
    "CAPTAIN_ASSISTANTS": "Помічники",
    "CAPTAIN_DOCUMENTS": "Документи",
    "CAPTAIN_RESPONSES": "Поширені запитання",
    "HOME": "Головна",
    "AGENTS": "Агенти",
    "AGENT_BOTS": "Боти",
    "AUDIT_LOGS": "Журнали аудиту",
    "WHATSAPP_TEMPLATES": "Шаблони WhatsApp",
    "BLOCKED_DOMAINS": "SPAM",
    "INBOXES": "Вхідні канали",
    "NOTIFICATIONS": "Сповіщення",
    "CANNED_RESPONSES": "Шаблонні відповіді",
    "INTEGRATIONS": "Інтеграції",
    "PROFILE_SETTINGS": "Налаштування профілю",
    "ACCOUNT_SETTINGS": "Налаштування облікового запису",
    "APPLICATIONS": "Застосунки",
    "LABELS": "Мітки",
    "CUSTOM_ATTRIBUTES": "Спеціальні атрибути",
    "AUTOMATION": "Автоматизація",
    "MACROS": "Макроси",
    "TEAMS": "Команди",
    "BILLING": "Оплата",
    "CUSTOM_VIEWS_FOLDER": "Папки",
    "CUSTOM_VIEWS_SEGMENTS": "Сегменти",
    "ALL_CONTACTS": "Усі контакти",
    "TAGGED_WITH": "Позначено міткою",
    "NEW_LABEL": "Нова мітка",
    "NEW_TEAM": "Нова команда",
    "NEW_INBOX": "Новий вхідний канал",
    "REPORTS_CONVERSATION": "Розмови",
    "CSAT": "CSAT",
    "LIVE_CHAT": "Онлайн-чат",
    "SMS": "SMS",
    "CAMPAIGNS": "Кампанії",
    "ONGOING": "Поточні",
    "ONE_OFF": "Одноразові",
    "REPORTS_SLA": "SLA",
    "REPORTS_BOT": "Бот",
    "REPORTS_AGENT": "Агенти",
    "REPORTS_LABEL": "Мітки",
    "REPORTS_INBOX": "Вхідні",
    "REPORTS_TEAM": "Команда",
    "REPORTS_PHONE": "Телефон",
    "WALLBOARD": "Інфопанель",
    "WALLBOARD_OVERVIEW": "Огляд",
    "WALLBOARD_QUEUES": "Черги",
    "WALLBOARD_AGENTS": "Огляд агентів",
    "DATA_ASSISTANT_CHAT": "Чат",
    "DATA_ASSISTANT_REPORTS": "Звіти",
    "NO_WAITING_CALLERS": "немає абонентів у черзі",
    "WAITING_CALLERS": "{count} абонентів у черзі",
    "SET_AVAILABILITY_TITLE": "Встановити себе як",
    "SET_YOUR_AVAILABILITY": "Встановити доступність",
    "AVAILABILITY_IMPERSONATING": "Заблоковано під час входу від імені цього користувача",
    "SLA": "SLA",
    "CUSTOM_ROLES": "Користувацькі ролі",
    "NEW_CONVERSATION": "Нова розмова",
    "DRAFT": "Чернетка",
    "BETA": "Бета",
    "REPORTS_OVERVIEW": "Огляд",
    "REAUTHORIZE": "Термін дії підключення вашого вхідного каналу закінчився, будь ласка, підключіть його знову,\n щоб і надалі отримувати та надсилати повідомлення",
    "HELP_CENTER": {
      "TITLE": "Центр допомоги",
      "ARTICLES": "Статті",
      "CATEGORIES": "Категорії",
      "LOCALES": "Локалі",
      "SETTINGS": "Налаштування",
      "DICTIONARY": "Словник"
    },
    "CHANNELS": "Канали",
    "SET_AUTO_OFFLINE": {
      "TEXT": "Автоматично позначати офлайн",
      "INFO_TEXT": "Дозвольте системі автоматично позначати вас як офлайн, коли ви не користуєтеся застосунком або панеллю керування.",
      "INFO_SHORT": "Автоматично позначати як офлайн, коли ви не користуєтеся застосунком."
    },
    "DOCS": "Читати документацію"
  },
  "BLOCKED_DOMAINS_SETTINGS": {
    "HEADER": "Заблоковані домени та контакти",
    "DESCRIPTION": "Список заблокованих доменів електронної пошти для цього облікового запису.",
    "NO_BLOCKED_DOMAINS": "Заблокованих доменів не знайдено.",
    "BLOCKED_CONTACTS_BTN": "Заблоковані контакти"
  },
  "BILLING_SETTINGS": {
    "TITLE": "Оплата",
    "DESCRIPTION": "Керуйте тут своєю підпискою, оновлюйте план і отримуйте більше можливостей для своєї команди.",
    "CURRENT_PLAN": {
      "TITLE": "Поточний план",
      "PLAN_NOTE": "Наразі ви підписані на план **{plan}** із **{quantity}** ліцензіями",
      "SEAT_COUNT": "Кількість місць",
      "RENEWS_ON": "Поновлюється"
    },
    "VIEW_PRICING": "Переглянути ціни",
    "MANAGE_SUBSCRIPTION": {
      "TITLE": "Керуйте своєю підпискою",
      "DESCRIPTION": "Переглядайте попередні рахунки, редагуйте платіжні дані або скасовуйте підписку.",
      "BUTTON_TXT": "Перейти до платіжного порталу"
    },
    "CAPTAIN": {
      "TITLE": "Captain",
      "DESCRIPTION": "Керуйте використанням і кредитами для Captain AI.",
      "BUTTON_TXT": "Купити більше кредитів",
      "DOCUMENTS": "Документи",
      "RESPONSES": "Відповіді",
      "UPGRADE": "Captain недоступний у безкоштовному плані. Оновіть план зараз, щоб отримати доступ до помічників, copilot та інших функцій."
    },
    "CHAT_WITH_US": {
      "TITLE": "Потрібна допомога?",
      "DESCRIPTION": "У вас виникли проблеми з оплатою? Ми тут, щоб допомогти.",
      "BUTTON_TXT": "Напишіть нам у чат"
    },
    "NO_BILLING_USER": "Ваш платіжний обліковий запис налаштовується. Будь ласка, оновіть сторінку та спробуйте ще раз."
  },
  "CREATE_ACCOUNT": {
    "NO_ACCOUNT_WARNING": "Ой! Ми не змогли знайти жодного облікового запису. Будь ласка, створіть новий обліковий запис, щоб продовжити.",
    "NEW_ACCOUNT": "Новий обліковий запис",
    "SELECTOR_SUBTITLE": "Створіть новий обліковий запис",
    "API": {
      "SUCCESS_MESSAGE": "Обліковий запис успішно створено",
      "EXIST_MESSAGE": "Обліковий запис уже існує",
      "ERROR_MESSAGE": "Не вдалося підключитися до сервера чату. Спробуйте пізніше"
    },
    "FORM": {
      "NAME": {
        "LABEL": "Назва компанії",
        "PLACEHOLDER": "Wayne Enterprises"
      },
      "SUBMIT": "Надіслати",
      "CANCEL": "Скасувати"
    }
  },
  "KEYBOARD_SHORTCUTS": {
    "TOGGLE_MODAL": "Переглянути всі комбінації клавіш",
    "TITLE": {
      "OPEN_CONVERSATION": "Відкрити розмову",
      "RESOLVE_AND_NEXT": "Завершити та перейти до наступної",
      "NAVIGATE_DROPDOWN": "Навігація елементами випадаючого списку",
      "RESOLVE_CONVERSATION": "Завершити розмову",
      "GO_TO_CONVERSATION_DASHBOARD": "Перейти до панелі розмов",
      "ADD_ATTACHMENT": "Додати вкладення",
      "GO_TO_CONTACTS_DASHBOARD": "Перейти до панелі контактів",
      "TOGGLE_SIDEBAR": "Перемкнути бічну панель",
      "GO_TO_REPORTS_SIDEBAR": "Перейти до бічної панелі звітів",
      "MOVE_TO_NEXT_TAB": "Перейти до наступної вкладки у списку розмов",
      "GO_TO_SETTINGS": "Перейти до налаштувань",
      "SWITCH_TO_PRIVATE_NOTE": "Перемкнутися на приватну нотатку",
      "SWITCH_TO_REPLY": "Перемкнутися на відповідь",
      "TOGGLE_SNOOZE_DROPDOWN": "Перемкнути випадаючий список відкладення",
      "AI_ASSIST_MENU": "AI-допомога",
      "AI_ASSIST_GRAMMAR": "Виправити граматику",
      "AI_ASSIST_UNIFY_LANG": "Уніфікувати мову повідомлення"
    }
  }
}
